import { type ITicketResolutionTimeData } from '../../../../interfaces/reports';

import { ticketsTimeDeserializer } from './time-deserializer';

export function ticketResolutionTimeDeserializer({ data }: any): ITicketResolutionTimeData {
  return {
    resolutionTime: ticketsTimeDeserializer(data.resolutionTime, 'resolution time'),
  };
}
